/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './approveJoinRequest.defs.js'
export { main as default } from './approveJoinRequest.defs.js'
